module.exports = __webpack_public_path__ + "img/icon_4.413d7ee1.png";